(() => {
  document.addEventListener('DOMContentLoaded', () => {
    // ---- Cache targets (guard in case some are missing) ---------------------
    const els = {
      full:  document.getElementById('logo-full'),
      print: document.getElementById('logo-print'),
      web:   document.getElementById('logo-web'),
    };

    const material = document.querySelector('input[name*="Free Plaque-2"]');

    // Hide all, then show one by key: 'full' | 'print' | 'web'
    function showOnly(key) {
      if (!els.full && !els.print && !els.web) return;
      ['full', 'print', 'web'].forEach(k => {
        const el = els[k];
        if (el) el.style.display = (k === key) ? 'block' : 'none';
      });
    }

    // Map radio values → which logo to show
    function logoKeyFor(valueRaw) {
      const v = (valueRaw || '').trim();
      if (v === 'Print') return 'print';
      if (v === 'Website') return 'web';
      if (v === 'Social/Email/Website') return 'full';
      return null; // unknown value: show nothing / keep current
    }

    // Delegated listener so it survives dynamic re-renders
    document.addEventListener('change', (event) => {
      if (!event.target.matches('input[type="radio"][name*="License Usage-1"]')) return;
      const key = logoKeyFor(event.target.value);
      if (key) showOnly(key);
    });

    // Initial state (if a radio is pre-checked)
    const initial = document.querySelector('input[type="radio"][name*="License Usage-1"]:checked');
    if (initial) {
      const key = logoKeyFor(initial.value);
      if (key) showOnly(key);
    }

    // Re-init when a Shopify section reloads (optional, but handy)
    document.addEventListener('shopify:section:load', () => {
      const checked = document.querySelector('input[type="radio"][name*="License Usage-1"]:checked');
      const key = checked ? logoKeyFor(checked.value) : null;
      if (key) showOnly(key);
    });

    // --- Require variant material  ------------------------------------------
    

    // ---- Comment field character count -------------------------------------
    const commentField = document.getElementById('comments');
    const charCountDisplay = document.getElementById('charCount');
    const MAX_LEN = 255;

    function updateCharCount() {
      if (!commentField || !charCountDisplay) return;
      const remaining = Math.max(0, MAX_LEN - commentField.value.length);
      charCountDisplay.textContent = `${remaining} characters remaining`;
    }

    if (commentField && charCountDisplay) {
      // Initialize & listen
      updateCharCount();
      commentField.addEventListener('input', updateCharCount);
    }
  });
})();
